import { render, staticRenderFns } from "./cookie-modal.vue?vue&type=template&id=c1f0db22&"
import script from "./cookie-modal.vue?vue&type=script&lang=ts&"
export * from "./cookie-modal.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports